import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type RfqQuoteDeleteParams = {
  quoteLineUUID: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqQuoteDeleteMutation = () =>
  useMutation<any, ErrorDTO, RfqQuoteDeleteParams>({
    mutationFn: async (params: RfqQuoteDeleteParams) => {
      try {
        const res = await client.delete(
          `rfq/quote/delete/${params.quoteLineUUID}`
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
